export const API_BASE_URL = "https://chatbot.theqpixel.com";
// export const API_BASE_URL = "http://192.168.1.102:5500";
